"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var _commonDesign = require("@sial/common-design");
var brandIdentity = process.env.BRAND_IDENTITY || 'SigmaAldrich';
var theme = (0, _commonDesign.loadTheme)(_commonDesign.OurBrands[brandIdentity]);
exports.theme = theme;